import { useAuth } from 'app/auth/hooks/useAuth';
import type { ISendbirdConnectionState } from '../types';

export const useIsConnectionPending = ({
    isConnected,
    isConnecting,
    connectionError,
}: Pick<ISendbirdConnectionState, 'isConnected' | 'isConnecting' | 'connectionError'>): boolean => {
    const { meData } = useAuth();
    return Boolean(meData?.current_pathway?.id) && !isConnected && !isConnecting && !connectionError;
};
